import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "C:\\Users\\wonde\\Downloads\\stellarscholar (9)\\stellarscholar\\src\\contexts\\AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\wonde\\Downloads\\stellarscholar (9)\\stellarscholar\\src\\styles\\index.css");
